import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cx } from "../utils/cx";
import styles from "./Button.module.css";

export type ButtonVariant =
  | "primary"
  | "secondary"
  | "destructive"
  | "tool"
  | "add";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** One of the five KCC button variants. Defaults to "secondary". */
  variant?: ButtonVariant;
  children: ReactNode;
}

/**
 * The KCC button. Every clickable action maps to one of five variants
 * (style-guide.md: Buttons). Do not add new variants — reassign to the
 * closest match.
 */
function Button({
  variant = "secondary",
  className,
  children,
  type = "button",
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={cx(styles.btn, styles[variant], className)}
      {...rest}
    >
      {children}
    </button>
  );
}

export default Button;
